import { Component, OnInit, ViewEncapsulation, Inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  AbstractControl
} from "@angular/forms";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { UserService } from "../../shared/services/user/user.service";
import { CustomerService } from "../../shared/services/customer/customer.service";
import { HttpErrorResponse } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-personal",
  templateUrl: "./personal.component.html",
  styleUrls: ["./personal.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class PersonalComponent implements OnInit {
  name: string = "";
  mobileNo: string = "";
  address: string = "";
  emailId: string = "";
  roleName: string = "";
  userDetails: any = {};

  constructor(public dialog: MatDialog, private userService: UserService) {
    this.setData();
  }

  ngOnInit() { }

  setData() {
    let userDetails = this.userService.getLoggedInUser();
    this.userDetails = userDetails;
    this.name = userDetails["name"] ? userDetails["name"] : "";
    this.mobileNo = userDetails["mobile"] ? userDetails["mobile"] : "-";
    this.address = userDetails["address"] ? userDetails["address"] : "-";
    this.emailId = userDetails["email"] ? userDetails["email"] : "";
    this.roleName = userDetails.role.roleName ? userDetails.role.roleName : "";
  }

  openEditPersonalDialog() {
    this.dialog.open(EditPersonalDialog, {
      height: "auto",
      width: "400px",
      panelClass: "full-modal",
      data: this.userDetails
    }).afterClosed().subscribe(() => {
      this.setData()
      this.userService.userDetailsSendUpdateEvent();
    });

  }

  openChangePasswordDialog() {
    this.dialog.open(ChangePasswordDialog, {
      height: "auto",
      width: "400px",
      panelClass: "full-modal"
    });

    return false;
  }

}

@Component({
  selector: "edit-personal-dialog",
  templateUrl: "personal.dialog.html"
})
export class EditPersonalDialog {
  personalForm: FormGroup;
  isSubmitted: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private customerService: CustomerService,
    private userService: UserService,
    public dialogRef: MatDialogRef<EditPersonalDialog>
  ) {
    this.createForm(data);
  }

  createForm(data: any) {
    this.personalForm = this.fb.group({
      name: [data.name, Validators.required],
      mobile: [data.mobile, Validators.compose([Validators.pattern('^[0-9]+$')])],
      address: data.address
    });
  }

  onSubmit(form: any) {
    if (!this.personalForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    form.customerId = this.data._id;

    this.customerService.update(form).subscribe(r => {
      this.userService.savePersonalDetailsToToken(form);
      this.dialogRef.close();
      this.isSubmitted = 0;
    }, err => {
      this.isSubmitted = 0;
    });
  }
}

@Component({
  selector: "change-password-dialog",
  templateUrl: "change-password.dialog.html"
})
export class ChangePasswordDialog {
  passwordForm: FormGroup;
  isSubmitted: number = 0;

  constructor(
    public dialogRef: MatDialogRef<EditPersonalDialog>,
    private userService: UserService,
    private fb: FormBuilder,
    private translate: TranslateService
  ) {
    this.createForm();
  }

  createForm(): void {
    this.passwordForm = this.fb.group(
      {
        oldPassword: ["", Validators.required],
        newPassword: [
          "",
          Validators.compose([
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(20)
          ])
        ],
        confirmPassword: ["", Validators.required]
      },
      {
        validator: this.MatchPassword // your validation method
      }
    );
  }

  MatchPassword(AC: AbstractControl) {
    let password = AC.get("newPassword").value; // to get value in input tag
    let confirmPassword = AC.get("confirmPassword").value; // to get value in input tag
    if (password != confirmPassword) {
      AC.get("confirmPassword").setErrors({ MatchPassword: true });
    } else {
      return null;
    }
  }

  onSubmit(form: any) {
    if (!this.passwordForm.valid) {
      return false;
    }
    this.isSubmitted = 1;
    this.userService
      .changePasswordService(form.oldPassword, form.newPassword)
      .subscribe(
        r => {
          this.dialogRef.close();
          this.isSubmitted = 0;
        },
        (err: HttpErrorResponse) => {
          this.isSubmitted = 0;
        }
      );
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/personal/personal.component.ts